export default __webpack_public_path__ + "static/media/europe_noir.21426f61.svg";